import React, { FC } from 'react'
import styles from '../../styles'
import { Grid } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from 'tss-react/mui'
import FormCreationContact from './components/FormCreationContact'

const CreationContact: FC = () => {
	const { classes, cx } = useStyles()

	const titleStyle = cx(
		classes.title2,
		classes.titleContainer
	)

	return (
		<Grid container item className={classes.creationContactContainer}>
			<Grid container item spacing="20px">
				<Grid container item>
					<span className={titleStyle}>
						<FormattedMessage
							id="creationContact.title"
							defaultMessage="Création du contact"
							description="Création du contact"
						/>
					</span>
				</Grid>
				<Grid container item>
					<Grid sx={{ padding: '0px 20px' }}>
						<FormCreationContact />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	creationContactContainer: {
		padding: '0px 20px'
	},
	titleContainer: {
		padding: 16
	}
}))

export default CreationContact